<template>
  <span>
    <a href="#" @click.prevent="$bvModal.show(modalId)"><i class="fa fa-lg fa-file mr-2"></i></a>
    <b-modal
      :id="modalId"
      size="xl"
      title="Lista Materiales"
      @show="onShow"
      body-class="p-0"
      ok-title="Imprimir"
      @ok="descargarPDF"
    >
      <div id="printArea">
        <h1>Plan Producción #{{ id }}</h1>
        <h3>{{ container_name }}({{ container_sku }}): {{ total_quantity }} Un</h3>
        <b-table :items="materials" :fields="fields"></b-table>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  name: "MaterialList",
  props: {
    container_id: {
      type: Number,
      required: true
    },
    container_name: {
      type: String,
      required: true
    },
    container_sku: {
      type: String,
      required: true
    },
    total_quantity: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    modalId() {
      return `modal-materiales-${this.id}`;
    }
  },
  data() {
    return {
      loading: false,
      ready: false,
      materials: [],
      fields: [
        {
          key: "container__name",
          label: "Formato"
        },
        {
          key: "container__sku",
          label: "Cód Formato"
        },
        {
          key: "supply__name",
          label: "Material"
        },
        {
          key: "supply__code",
          label: "Cód Material"
        },
        {
          key: "q_per_unit",
          label: "Q x Unidad"
        },
        {
          key: "total",
          label: "Total",
          class: "text-right font-weight-bold"
        }
      ]
    };
  },
  methods: {
    onShow() {
      this.loading = true;
      this.ready = false;
      this.getMaterials();
    },
    async getMaterials() {
      this.loading = true;
      try {
        const { data } = await this.$axios.get(`/production/recipe_list/${this.container_id}/${this.total_quantity}`);
        this.materials = data;
        this.ready = true;
      } catch (e) {
        this.$bvToast.toast("Error al cargar los materiales", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    },
    descargarPDF() {
      const printArea = document.getElementById("printArea");
      const html = printArea.innerHTML;
      const printWindow = window.open("", "_blank");

      printWindow.document.write("<html><head><title>Packapp</title></head><body>");
      printWindow.document.write(html);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  }
};
</script>
<style></style>
